// import React, { useState } from 'react';
// import { useAuth, useInvoice } from '../AuthContext';
// import { useNavigate } from 'react-router-dom';

// const Invoice = () => {
//   const { user } = useAuth();
//   const { setInvoiceNumber } = useInvoice();
//   const [clientName, setClientName] = useState('');
//   const [items, setItems] = useState([{ description: '', unitPrice: '', quantity: '', amount: 0 }]);
//   const [tax, setTax] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [error, setError] = useState('');

//   const navigate = useNavigate();

//   const handleInputChange = (index, event) => {
//     const { name, value } = event.target;
//     const newItems = [...items];
//     newItems[index][name] = value;
//     if (name === 'unitPrice' || name === 'quantity') {
//       newItems[index].amount = (newItems[index].unitPrice * newItems[index].quantity).toFixed(2);
//     }
//     setItems(newItems);
//   };

//   const handleAddRow = () => {
//     setItems([...items, { description: '', unitPrice: '', quantity: '', amount: 0 }]);
//   };

//   const handleDeleteRow = (index) => {
//     const newItems = items.filter((_, i) => i !== index);
//     setItems(newItems);
//   };

//   const calculateTotal = () => {
//     const subTotal = items.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
//     const taxAmount = subTotal * (parseFloat(tax || 0) / 100);
//     const discountAmount = subTotal * (parseFloat(discount || 0) / 100);
//     const total = subTotal + taxAmount - discountAmount;
//     return total.toFixed(2);
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     const invoiceNumber = `INV_${Date.now()}`;
//     const total = calculateTotal();
//     const date = new Date().toISOString();

//     const invoiceData = {
//       invoiceNumber,
//       userID: user.userID,
//       companyID: user.companyID,
//       total: parseFloat(total),
//       date,
//       clientName,
//       tax: parseFloat(tax),
//       discount: parseFloat(discount),
//       items: items.map(item => ({
//         invoiceNumber,
//         productName: item.description,
//         unitPrice: parseFloat(item.unitPrice),
//         quantity: parseFloat(item.quantity)
//       }))
//     };

//     try {
//       const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(invoiceData)
//       });

//       if (!response.ok) throw new Error('Failed to submit invoice');
//       setInvoiceNumber(invoiceNumber);
//       navigate('/viewPort');
//     } catch (error) {
//       setError('Failed to submit invoice');
//     }
//   };

//   return (
//     <div className="p-8 bg-white rounded-lg shadow-lg">
//       <h2 className="text-2xl font-semibold mb-6">Create Invoice</h2>
//       <form onSubmit={handleSubmit}>
//         {/* Client Name Input */}
//         <div className="mb-6">
//           <label className="block text-gray-700 mb-2">Client Name:</label>
//           <input
//             type="text"
//             value={clientName}
//             onChange={(e) => setClientName(e.target.value)}
//             required
//             className="w-full p-2 border rounded"
//           />
//         </div>

//        {/* Invoice Table */}
// <div className="w-full overflow-x-auto mb-6">
//   <table className="w-full border-collapse">
//     <thead>
//       <tr className="bg-gray-200">
//         <th className="p-3">Description</th>
//         <th className="p-3">Unit Price</th>
//         <th className="p-3">Quantity</th>
//         <th className="p-3">Amount</th>
//         <th className="p-3">Actions</th>
//       </tr>
//     </thead>
//     <tbody>
//       {items.map((item, index) => (
//         <tr key={index} className="text-center">
//           <td>
//             <input
//               type="text"
//               name="description"
//               value={item.description}
//               onChange={(e) => handleInputChange(index, e)}
//               className="w-full p-2 border rounded"
//             />
//           </td>
//           <td>
//             <input
//               type="number"
//               name="unitPrice"
//               value={item.unitPrice}
//               onChange={(e) => handleInputChange(index, e)}
//               className="w-full p-2 border rounded"
//             />
//           </td>
//           <td>
//             <input
//               type="number"
//               name="quantity"
//               value={item.quantity}
//               onChange={(e) => handleInputChange(index, e)}
//               className="w-full p-2 border rounded"
//             />
//           </td>
//           <td>{item.amount}</td>
//           <td>
//             <button type="button" onClick={handleAddRow} className="text-blue-500">
//               +
//             </button>
//             <button
//               type="button"
//               onClick={() => handleDeleteRow(index)}
//               className="text-red-500 ml-2"
//             >
//               -
//             </button>
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// </div>


//         {/* Tax and Discount Inputs */}
//         <div className="grid grid-cols-2 gap-4 mb-6">
//           <div>
//             <label className="block text-gray-700 mb-2">Tax (%)</label>
//             <input
//               type="number"
//               value={tax}
//               onChange={(e) => setTax(e.target.value)}
//               className="w-full p-2 border rounded text-right"
//               placeholder="0"
//               min={0}
//             />
//           </div>
//           <div>
//             <label className="block text-gray-700 mb-2">Discount (%)</label>
//             <input
//               type="number"
//               value={discount}
//               onChange={(e) => setDiscount(e.target.value)}
//               className="w-full p-2 border rounded text-right"
//               placeholder="0"
//               min={0}
//             />
//           </div>
//         </div>

//         {/* Total Section */}
//         <div className="flex justify-between items-center font-bold text-xl">
//           <span>Total:</span>
//           <span>Rs.{calculateTotal()}</span>
//         </div>

//         {error && <p className="text-red-500 mt-4">{error}</p>}

//         {/* Submit Button */}
//         <div className="mt-6 text-center">
//           <button type="submit" className="bg-green-500 text-white py-3 px-6 rounded">
//             Submit
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Invoice;


// import React, { useState, useEffect } from 'react';
// import { useAuth, useInvoice } from '../AuthContext';
// import { useNavigate } from 'react-router-dom';

// const Invoice = () => {
//   const { user } = useAuth();
//   const { setInvoiceNumber } = useInvoice();
//   const [clientName, setClientName] = useState('');
//   const [items, setItems] = useState([{ description: '', unitPrice: '', quantity: '', amount: 0 }]);
//   const [tax, setTax] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [isAdvancePayment, setIsAdvancePayment] = useState(false); // Track if it's an advance payment
//   const [advanceAmount, setAdvanceAmount] = useState(0); // Track the advance payment amount
//   const [error, setError] = useState('');
//   const [paymentHistory, setPaymentHistory] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Fetch customer payment status (advance or full payment) from the API
//     const fetchPaymentStatus = async () => {
//       const response = await fetch(`/api/payment-status?customerId=${user.userID}`);
//       const data = await response.json();
//       setIsAdvancePayment(data.isAdvance); // Assuming the API returns a flag for advance payment
//     };
//     fetchPaymentStatus();
//   }, [user.userID]);

//   const handleInputChange = (index, event) => {
//     const { name, value } = event.target;
//     const newItems = [...items];
//     newItems[index][name] = value;
//     if (name === 'unitPrice' || name === 'quantity') {
//       newItems[index].amount = (newItems[index].unitPrice * newItems[index].quantity).toFixed(2);
//     }
//     setItems(newItems);
//   };

//   const handleAddRow = () => {
//     setItems([...items, { description: '', unitPrice: '', quantity: '', amount: 0 }]);
//   };

//   const handleDeleteRow = (index) => {
//     const newItems = items.filter((_, i) => i !== index);
//     setItems(newItems);
//   };

//   const calculateTotal = () => {
//     const subTotal = items.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
//     const taxAmount = subTotal * (parseFloat(tax || 0) / 100);
//     const discountAmount = subTotal * (parseFloat(discount || 0) / 100);
//     const total = subTotal + taxAmount - discountAmount;
//     return total.toFixed(2);
//   };

//   const calculateFullPaymentAmount = () => {
//     const total = parseFloat(calculateTotal());
//     const remainingAmount = total - (isAdvancePayment ? parseFloat(advanceAmount) : 0);
//     return remainingAmount.toFixed(2);
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     const invoiceNumber = `INV_${Date.now()}`;
//     const total = calculateTotal();
//     const date = new Date().toISOString();

//     const invoiceData = {
//       invoiceNumber,
//       userID: user.userID,
//       companyID: user.companyID,
//       total: parseFloat(total),
//       date,
//       clientName,
//       tax: isAdvancePayment ? 0 : parseFloat(tax), // Don't apply tax for advance payment
//       discount: isAdvancePayment ? 0 : parseFloat(discount), // Don't apply discount for advance payment
//       items: items.map(item => ({
//         invoiceNumber,
//         productName: item.description,
//         unitPrice: parseFloat(item.unitPrice),
//         quantity: parseFloat(item.quantity),
//       })),
//       advanceAmount: isAdvancePayment ? parseFloat(advanceAmount) : 0, // Include advance payment if selected
//     };

//     try {
//       const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(invoiceData)
//       });

//       if (!response.ok) throw new Error('Failed to submit invoice');
//       setInvoiceNumber(invoiceNumber);
//       navigate('/viewPort');
//     } catch (error) {
//       setError('Failed to submit invoice');
//     }
//   };

//   // const fetchPaymentHistory = async () => {
//   //   if (!clientName) {
//   //     setPaymentHistory([]);
//   //     return;
//   //   }
//   //   try {
//   //     console.log('Fetching payment history for:', clientName);
//   //     const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice/Client/${clientName}`);
      
//   //     if (!response.ok) {
//   //       console.log('Failed to fetch payment history:', response.statusText);
//   //       throw new Error('No payment history found');
//   //     }
      
//   //     const data = await response.json();
//   //     console.log('Fetched payment history:', data);  // Log data to check if it is as expected
//   //     setPaymentHistory(data);
//   //   } catch (error) {
//   //     console.error('Error fetching payment history:', error);
//   //     setPaymentHistory([]);
//   //   }
//   // };
  
//   const fetchPaymentHistory = async () => {
//     if (!clientName) {
//       setPaymentHistory([]);
//       return;
//     }
//     try {
//       console.log('Fetching unsettled invoices for:', clientName);
//       const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice/Unsettled/${clientName}`);
  
//       if (!response.ok) {
//         console.log('No unsettled invoices found:', response.statusText);
//         throw new Error('No unsettled invoices found');
//       }
  
//       const data = await response.json();
//       const invoices = data.$values || []; // Extract array correctly
  
//       console.log('Fetched unsettled invoices:', invoices);
  
//       // Check if data.$values exists and if it's an array
//       if (!Array.isArray(invoices)) {
//         console.error("Expected an array but got:", typeof invoices);
//         setPaymentHistory([]);
//         return;
//       }
  
//       // Process the invoices and create items
//       const unsettledItems = invoices.flatMap(invoice =>
//         Array.isArray(invoice.items?.$values)
//           ? invoice.items.$values.map(item => ({
//               description: item.productName,
//               unitPrice: item.unitPrice,
//               quantity: item.quantity,
//               amount: (item.unitPrice * item.quantity).toFixed(2),
//               isUnsettled: true,
//             }))
//           : []
//       );
  
//       setItems(unsettledItems.length > 0 ? unsettledItems : [{ description: '', unitPrice: '', quantity: '', amount: 0 }]);
  
//     } catch (error) {
//       console.error('Error fetching unsettled invoices:', error);
//       setPaymentHistory([]);
//     }
//   };
  
  

//   return (
//     <div className="p-8 bg-white rounded-lg shadow-lg">
//       <h2 className="text-2xl font-semibold mb-6">Create Invoice</h2>
//       <form onSubmit={handleSubmit}>
//   {/* Client Name Input */}
//   <div className="mb-6 flex items-center">
//     <label className="block text-gray-700 mb-2 mr-4">Client Name:</label>
//     <input
//       type="text"
//       value={clientName}
//       onChange={(e) => setClientName(e.target.value)}
//       required
//       className="w-full p-2 border rounded mr-4"
//     />
//     <button
//       type="button"
//       onClick={fetchPaymentHistory}
//       className="bg-blue-500 text-white px-4 py-2 rounded"
//     >
//       Search
//     </button>
//   </div>

//   {/* Payment History Table */}
//   {paymentHistory.length > 0 && (
//     <div className="mt-4 p-4 border rounded bg-gray-100">
//       <h3 className="text-lg font-semibold">Payment History</h3>
     
//     </div>
//   )}

//   {/* Invoice Table */}
//   <div className="w-full overflow-x-auto mb-6">
//     <table className="w-full border-collapse">
//       <thead>
//         <tr className="bg-gray-200">
//           <th className="p-3">Description</th>
//           <th className="p-3">Unit Price</th>
//           <th className="p-3">Quantity</th>
//           <th className="p-3">Amount</th>
//           <th className="p-3">Actions</th>
//         </tr>
//       </thead>
//       {/* <tbody>
//         {items.map((item, index) => (
//           <tr key={index} className="text-center">
//             <td>
//               <input
//                 type="text"
//                 name="description"
//                 value={item.description}
//                 onChange={(e) => handleInputChange(index, e)}
//                 className="w-full p-2 border rounded"
//               />
//             </td>
//             <td>
//               <input
//                 type="number"
//                 name="unitPrice"
//                 value={item.unitPrice}
//                 onChange={(e) => handleInputChange(index, e)}
//                 className="w-full p-2 border rounded"
//               />
//             </td>
//             <td>
//               <input
//                 type="number"
//                 name="quantity"
//                 value={item.quantity}
//                 onChange={(e) => handleInputChange(index, e)}
//                 className="w-full p-2 border rounded"
//               />
//             </td>
//             <td>{item.amount}</td>
//             <td>
//               <button type="button" onClick={handleAddRow} className="text-blue-500">
//                 +
//               </button>
//               <button
//                 type="button"
//                 onClick={() => handleDeleteRow(index)}
//                 className="text-red-500 ml-2"
//               >
//                 -
//               </button>
//             </td>
//           </tr>
//         ))}
//       </tbody> */}

// <tbody>
//   {items.map((item, index) => (
//     <tr key={index} className="text-center">
//       <td>
//         <input
//           type="text"
//           name="description"
//           value={item.description}
//           onChange={(e) => handleInputChange(index, e)}
//           className="w-full p-2 border rounded"
//           readOnly={item.isUnsettled} // Make read-only if it's an unsettled item
//         />
//       </td>
//       <td>
//         <input
//           type="number"
//           name="unitPrice"
//           value={item.unitPrice}
//           onChange={(e) => handleInputChange(index, e)}
//           className="w-full p-2 border rounded"
//           readOnly={item.isUnsettled}
//         />
//       </td>
//       <td>
//         <input
//           type="number"
//           name="quantity"
//           value={item.quantity}
//           onChange={(e) => handleInputChange(index, e)}
//           className="w-full p-2 border rounded"
//           readOnly={item.isUnsettled}
//         />
//       </td>
//       <td>{item.amount}</td>
//       <td>
//         {!item.isUnsettled && (
//           <>
//             <button type="button" onClick={handleAddRow} className="text-blue-500">
//               +
//             </button>
//             <button type="button" onClick={() => handleDeleteRow(index)} className="text-red-500 ml-2">
//               -
//             </button>
//           </>
//         )}
//       </td>
//     </tr>
//   ))}
// </tbody>

//     </table>
//   </div>
//         {/* Advance Payment Checkbox */}
//         <div className="mb-6">
//           <label className="block text-gray-700 mb-2">
//             <input
//               type="checkbox"
//               checked={isAdvancePayment}
//               onChange={() => setIsAdvancePayment(!isAdvancePayment)}
//               className="mr-2"
//             />
//             Is this an advance payment?
//           </label>
//         </div>

//         {/* Advance Payment Amount Field */}
//         {isAdvancePayment && (
//           <div className="mb-6">
//             <label className="block text-gray-700 mb-2">Advance Payment Amount:</label>
//             <input
//               type="number"
//               value={advanceAmount}
//               onChange={(e) => setAdvanceAmount(e.target.value)}
//               className="w-full p-2 border rounded text-right"
//               min={0}
//               required
//             />
//           </div>
//         )}

//         {/* Tax and Discount Inputs (only show if full payment) */}
//         {!isAdvancePayment && (
//           <div className="grid grid-cols-2 gap-4 mb-6">
//             <div>
//               <label className="block text-gray-700 mb-2">Tax (%)</label>
//               <input
//                 type="number"
//                 value={tax}
//                 onChange={(e) => setTax(e.target.value)}
//                 className="w-full p-2 border rounded text-right"
//                 placeholder="0"
//                 min={0}
//               />
//             </div>
//             <div>
//               <label className="block text-gray-700 mb-2">Discount (%)</label>
//               <input
//                 type="number"
//                 value={discount}
//                 onChange={(e) => setDiscount(e.target.value)}
//                 className="w-full p-2 border rounded text-right"
//                 placeholder="0"
//                 min={0}
//               />
//             </div>
//           </div>
//         )}

//         {/* Total Section */}
//         <div className="flex justify-between items-center font-bold text-xl mb-4">
//           <span>Total:</span>
//           <span>Rs.{calculateTotal()}</span>
//         </div>

//         {/* Amount to Pay (after deducting advance payment) */}
//         {isAdvancePayment && (
//           <div className="flex justify-between items-center font-bold text-xl">
//             <span>Amount Remaining (after Advance):</span>
//             <span>Rs.{calculateFullPaymentAmount()}</span>
//           </div>
//         )}

//         {error && <p className="text-red-500 mt-4">{error}</p>}

//         {/* Submit Button */}
//         <div className="mt-6 text-center">
//           <button type="submit" className="bg-green-500 text-white py-3 px-6 rounded">
//             Submit
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Invoice;


//new try

import React, { useState, useEffect } from 'react';
import { useAuth, useInvoice } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';

const Invoice = () => {
  const { user } = useAuth();
  const { setInvoiceNumber } = useInvoice();
  const [clientName, setClientName] = useState('');
  const [items, setItems] = useState([{ description: '', unitPrice: '', quantity: '', amount: 0  , remainingBalance:0}]);
  const [tax, setTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [isAdvancePayment, setIsAdvancePayment] = useState(false);
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0); // Changed from paymentAmount to paidAmount
  const [error, setError] = useState('');
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [unsettledPaymentData, setUnsettledPaymentData] = useState(null);

  

  const [mobileNumber, setMobileNumber] = useState('');
  const [mobileError, setMobileError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      const response = await fetch(`/api/payment-status?customerId=${user.userID}`);
      const data = await response.json();
      setIsAdvancePayment(data.isAdvance);
    };
    fetchPaymentStatus();
  }, [user.userID]);

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newItems = [...items];
    newItems[index][name] = value;
    if (name === 'unitPrice' || name === 'quantity') {
      newItems[index].amount = (newItems[index].unitPrice * newItems[index].quantity).toFixed(2);
    }
    setItems(newItems);
  };

  const handleAddRow = () => {
    setItems([...items, { description: '', unitPrice: '', quantity: '', amount: 0 }]);
  };
  
  const handleDeleteRow = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  // const calculateTotal = () => {
  //   const subTotal = items.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
  //   const taxAmount = subTotal * (parseFloat(tax || 0) / 100);
  //   const discountAmount = subTotal * (parseFloat(discount || 0) / 100);
  //   const total = subTotal + taxAmount - discountAmount;
  //   return total.toFixed(2);
  // };

  const calculateTotal = () => {
    // Calculate total for both unsettled items and new items
    const unsettledTotal = items.reduce((acc, item) => acc + (item.isUnsettled ? parseFloat(item.amount || 0) : 0), 0);
    const newItemsTotal = items.reduce((acc, item) => acc + (!item.isUnsettled ? parseFloat(item.amount || 0) : 0), 0);
    const subTotal = unsettledTotal + newItemsTotal;
    
    const taxAmount = subTotal * (parseFloat(tax || 0) / 100);
    const discountAmount = subTotal * (parseFloat(discount || 0) / 100);
    
    return (subTotal + taxAmount - discountAmount).toFixed(2);
  };
  
  
  

  const calculateFullPaidAmount = () => {
    const total = parseFloat(calculateTotal());
    const remainingAmount = total - (isAdvancePayment ? parseFloat(advanceAmount) : 0);
    return remainingAmount.toFixed(2);
  };

  const calculateRemainingBalance = () => {
    const totalAmount = parseFloat(calculateTotal());
    const paidAmountFloat = parseFloat(paidAmount);
    const remainingBalance = totalAmount - paidAmountFloat;
    return remainingBalance.toFixed(2);
  };
  

  const checkMobileNumberExists = async () => {
    if (!mobileNumber) return false;
  
    try {
      const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice/check-mobile/${mobileNumber}`);
      const data = await response.json();
  
      console.log("Mobile Check Response:", data);
  
      if (data.exists) {
        if (data.clientName !== clientName) { // Check if the name matches the existing one
          setMobileError('This mobile number is already associated with a different client name.');
          return true;
        } else {
          setMobileError('');
          return false; // Phone number and client name match, proceed
        }
      } else {
        setMobileError('');
        return false; // Phone number doesn't exist, proceed
      }
    } catch (error) {
      console.error("Error fetching mobile check:", error);
      return false;
    }
  };
  
  
  
  
  const handleMobileChange = async (e) => {
    const number = e.target.value;
    setMobileNumber(number);
    
    const isDuplicate = await checkMobileNumberExists();
    if (isDuplicate) {
      setMobileError('This mobile number is already registered.');
    } else {
      setMobileError('');
    }
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
  
    // Check if mobile number already exists
    const isMobileDuplicate = await checkMobileNumberExists(mobileNumber);
    if (isMobileDuplicate) {
      setError('This mobile number is already registered.');
      return; // Stop form submission
    }
  
  
    const invoiceNumber = `INV_${Date.now()}`;
    const total = calculateTotal();
    const date = new Date().toISOString();
  
    const invoiceData = {
      invoiceNumber,
      userID: user.userID,
      companyID: user.companyID,
      total: parseFloat(total),
      date,
      mobileNumber, 
      clientName,
      tax: isAdvancePayment ? 0 : parseFloat(tax),
      discount: isAdvancePayment ? 0 : parseFloat(discount),
      items: items.map(item => ({
        invoiceNumber,
        productName: item.description,
        unitPrice: parseFloat(item.unitPrice),
        quantity: parseFloat(item.quantity),
      })),
      advanceAmount: isAdvancePayment ? parseFloat(advanceAmount) : 0,
      paidAmount: parseFloat(paidAmount),
      remainingBalance: calculateRemainingBalance(),
    };
  
    try {
      const response = await fetch('https://invoice.dockyardsoftware.com/api/Invoice', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(invoiceData),
      });
  
      if (!response.ok) throw new Error('Failed to submit invoice');
      setInvoiceNumber(invoiceNumber);
      navigate('/viewPort');
    } catch (error) {
      setError('Failed to submit invoice');
    }
  };
  

 
  
  
  // const fetchPaymentHistory = async () => {
  //   if (!clientName || !mobileNumber) {
  //     setPaymentHistory([]);
  //     return;
  //   }
  
  //   try {
  //     const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice/Unsettled?clientName=${clientName}&mobileNumber=${mobileNumber}`);
      
  //     // Log the response to check the data
  //     const data = await response.json();
  //     console.log("Fetched Payment History:", data); // Log the data to see the response
  
  //     if (!response.ok) throw new Error('No unsettled invoices found');
      
  //     const invoices = data.$values || [];
  
  //     // Filter out invoices where the remaining balance is 0
  //     const unsettledInvoices = invoices.filter(invoice => invoice.remainingBalance > 0);
  
  //     const unsettledItems = unsettledInvoices.flatMap(invoice =>
  //       Array.isArray(invoice.items?.$values)
  //         ? invoice.items.$values.map(item => ({
  //             description: item.productName,
  //             unitPrice: item.unitPrice,
  //             quantity: item.quantity,
  //             amount: (item.unitPrice * item.quantity).toFixed(2),
  //             remainingBalance: invoice.remainingBalance , // Ensure remainingBalance is available
  //             isUnsettled: true,
  //           }))
  //         : []
  //     );
      
  
  //     if (unsettledItems.length > 0) {
  //       setItems(unsettledItems);
  //     } else {
  //       setItems([{ description: '', unitPrice: '', quantity: '', amount: 0, remainingBalance: 0 }]); // Reset grid
  //     }
  //   } catch (error) {
  //     console.error("Error fetching payment history:", error);
  //     setItems([{ description: '', unitPrice: '', quantity: '', amount: 0, remainingBalance: 0 }]); // Reset grid
  //   }
  // };


  const fetchPaymentHistory = async () => {
    if (!clientName || !mobileNumber) {
      setPaymentHistory([]);
      return;
    }
  
    try {
      const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice/Unsettled?clientName=${clientName}&mobileNumber=${mobileNumber}`);
      const data = await response.json();
      if (!response.ok) throw new Error('No unsettled invoices found');
      
      const invoices = data.$values || [];
      const unsettledInvoices = invoices.filter(invoice => invoice.remainingBalance > 0);
  
      const unsettledItems = unsettledInvoices.flatMap(invoice =>
        Array.isArray(invoice.items?.$values)
          ? invoice.items.$values.map(item => ({
              description: item.productName,
              unitPrice: item.unitPrice,
              quantity: item.quantity,
              amount: (item.unitPrice * item.quantity).toFixed(2),
              remainingBalance: invoice.remainingBalance, // Ensure remainingBalance is available
              isUnsettled: true,
            }))
          : []
      );
  
      // If there are unsettled items, set the items and adjust the total calculation
      if (unsettledItems.length > 0) {
        setItems(unsettledItems);
      } else {
        setItems([{ description: '', unitPrice: '', quantity: '', amount: 0, remainingBalance: 0 }]); // Reset grid if no unsettled invoices
      }
    } catch (error) {
      console.error("Error fetching payment history:", error);
      setItems([{ description: '', unitPrice: '', quantity: '', amount: 0, remainingBalance: 0 }]); // Reset grid on error
    }
  };
  
  const checkMobileNumberExistsh = async () => {
    if (!mobileNumber || !clientName) return false;
  
    try {
      const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice/check-mobile-exists/${mobileNumber}`);
      const data = await response.json();
  
      if (data.exists) {
        // Check if the client name matches
        if (data.clientName === clientName) {
          setMobileError('This is a registered customer.');
          return true;
        } else {
          setMobileError('This mobile number is already associated with a different client name.');
          return true;
        }
      } else {
        setMobileError('');
        return false;
      }
    } catch (error) {
      console.error("Error fetching mobile check:", error);
      return false;
    }
  };
  
  

  return (
    <div className="p-8 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold mb-6">Create Invoice</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-6 ">
          <label className="block text-gray-700 mb-2 mr-4">Client Name:</label>
          <input
            type="text"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            required
            className="w-full p-2 border rounded mr-4"
          />



       

          
        </div>

        <div className="mb-6 relative">
  <input
    type="text"
    value={mobileNumber}
    onChange={handleMobileChange}
    className="w-full p-2 border rounded pr-10" // Added padding to the right for the icon
    placeholder="Enter Mobile Number"
    required
  />
<FaSearch
  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
  onClick={async () => {
    const isDuplicate = await checkMobileNumberExistsh();
    if (isDuplicate) {
      // If the combination matches, the error will be 'This is a registered customer.'
      // Else, it will show the 'This mobile number is already associated with a different client name.'
    } else {
      setMobileError(''); // Clear error if no issue
    }
  }}
/>



</div>

  {mobileError && <p className="text-red-500 mt-1">{mobileError}</p>}

<div>
<button
            type="button"
            onClick={fetchPaymentHistory}
            className="bg-blue-500 text-white px-4 py-2 rounded mb-5"
          >
            Search
          </button>

          </div>

      

        <div className="w-full overflow-x-auto mb-6">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="p-3">Description</th>
                <th className="p-3">Unit Price</th>
                <th className="p-3">Quantity</th>
                <th className="p-3">Amount</th>
                <th className="p-3">Remaining Amount</th>
                <th className="p-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index} className="text-center">
                  <td>
                    <input
                      type="text"
                      name="description"
                      value={item.description}
                      onChange={(e) => handleInputChange(index, e)}
                      className="w-full p-2 border rounded"
                      readOnly={item.isUnsettled}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="unitPrice"
                      value={item.unitPrice}
                      onChange={(e) => handleInputChange(index, e)}
                      className="w-full p-2 border rounded"
                      readOnly={item.isUnsettled}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="quantity"
                      value={item.quantity}
                      onChange={(e) => handleInputChange(index, e)}
                      className="w-full p-2 border rounded"
                      readOnly={item.isUnsettled}
                    />
                  </td>
                  <td>{item.amount}</td>
                  <td>{item.remainingBalance}</td>
                  <td>
  <button type="button" onClick={handleAddRow} className="text-blue-500">+</button>
  {!item.isUnsettled && (
    <button type="button" onClick={() => handleDeleteRow(index)} className="text-red-500 ml-2">-</button>
  )}
</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {paymentHistory.length === 0 && items.length > 0 && !items.some(item => item.isUnsettled) && (
  <div className="mb-6">
    <label className="block text-gray-700 mb-2">
      <input
        type="checkbox"
        checked={isAdvancePayment}
        onChange={() => setIsAdvancePayment(!isAdvancePayment)}
        className="mr-2"
      />
      Is this an advance payment?
    </label>
  </div>
)}


{isAdvancePayment && paymentHistory.length === 0 && (
  <div className="mb-6">
    <label className="block text-gray-700 mb-2">Advance Payment Amount:</label>
    <input
      type="number"
      value={advanceAmount}
      onChange={(e) => setAdvanceAmount(e.target.value)}
      className="w-full p-2 border rounded text-right"
      min={0}
      required
    />
  </div>
)}


        {!isAdvancePayment && (
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div>
              <label className="block text-gray-700 mb-2">Tax (%)</label>
              <input
                type="number"
                value={tax}
                onChange={(e) => setTax(e.target.value)}
                className="w-full p-2 border rounded text-right"
                placeholder="0"
                min={0}
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-2">Discount (%)</label>
              <input
                type="number"
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
                className="w-full p-2 border rounded text-right"
                placeholder="0"
                min={0}
              />
            </div>
          </div>
        )}

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Paid Amount:</label>
          <input
            type="number"
            value={paidAmount}
            onChange={(e) => setPaidAmount(e.target.value)}
            className="w-full p-2 border rounded text-right"
            min={0}
            required
          />
        </div>

        <div className="flex justify-between items-center font-bold text-xl mb-4">
          <span>Total:</span>
          <span>Rs.{calculateTotal()}</span>
        </div>

        {isAdvancePayment && (
          <div className="flex justify-between items-center font-bold text-xl">
            <span>Amount Remaining (after Advance):</span>
            <span>Rs.{calculateFullPaidAmount()}</span>
          </div>
        )}

        {paidAmount > 0 && !isAdvancePayment && (
          <div className="flex justify-between items-center font-bold text-xl mb-4">
            <span>Remaining Balance:</span>
            <span>Rs.{calculateRemainingBalance()}</span>
          </div>
        )}

        {paidAmount > 0 && isAdvancePayment && (
          <div className="flex justify-between items-center font-bold text-xl mb-4">
            <span>Remaining Balance (after Advance):</span>
            <span>Rs.{calculateRemainingBalance()}</span>
          </div>
        )}

        {error && <p className="text-red-500 mt-4">{error}</p>}

        <div className="mt-6 text-center">
          <button type="submit" className="bg-blue-500 text-white px-6 py-2 rounded">Submit Invoice</button>
        </div>
      </form>
    </div>
  );
};

export default Invoice;
